<div class="flex flex-col">
  <mat-label>{{ to.label }}</mat-label>
  <mat-form-field>
    <input type="text" placeholder="{{ to.label }}" matInput [formControl]="formControl" [matAutocomplete]="auto" />
    <mat-autocomplete
      #auto="matAutocomplete"
      [displayWith]="displayFn"
      (optionSelected)="languageChanged($event.option)"
    >
      <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
        {{ option.label }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
</div>
